<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="2">
                <strong>{{ $t('AccountCirculation') }}</strong>

              </CCol>

            </CRow>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol col="3">
                <CSelect
                    :value.sync="selected_type"
                    :options="[{label:$t('all'),value:0},{label:$t('tables.creditor'),value:1},{label:$t('tables.debtor'),value:2}]"
                />
              </CCol>
              <CCol col="3">
                <CSelect
                    :value.sync="selected_person_type"
                    :options="[{value: 0, label: $t('all')},{value: 163, label: $t('Suppliers')},{value: 80, label: $t('Customers')},{value: 82, label: $t('buttons.employee')}]"
                />
              </CCol>
              <CCol col="1">
                <CButton @click="get_lists()" color="dark"
                         size="sm">
                  <CIcon size="sm" name="cil-zoom"/>
                </CButton>
              </CCol>
              <CCol col="1">
                <CButton
                    class="mr-1"
                    size="sm"
                    @click="print_with_header_title_height(body_id,header_id,footer_id,'print',100,100)"
                    color="secondary"
                >{{ $t("buttons.print") }}
                </CButton>
              </CCol>
            </CRow>
            <div :id="header_id"></div>
            <div :id="footer_id"></div>
            <div :id="body_id">
              <CDataTableFixed
                  :items="items_filtered"
                  :fields="fields"
                  :items-per-page="200"
                  hover
                  height="300px"
                  @row-clicked="table_row_clicked"

                  column-filter
                  border
                  :pagination="get_pagination"
                  striped
              >
                <template #row_id="{item,index}">

                  <td>
                    <p class="text-center">{{ index + 1 }}</p>

                  </td>

                </template>

                <template #amount="{item}">
                  <td :style="'text-align:right'">
                    <p style="text-align:right">{{ get_currency(item.amount) }}</p>
                  </td>
                </template>
                <template #docDate="{item}">
                  <td>
                    <p style="text-align: center">{{
                        get_date(item.docDate)
                      }}</p>
                  </td>
                </template>
                <template #creditor="{item}">
                  <td :style="'text-align:right'">
                    <p style="text-align:right">{{ get_currency(Math.abs(item.creditor)) }}</p>
                  </td>
                </template>
                <template #balanceBefore="{item}">
                  <td :style="'text-align:right'">
                    <p style="text-align:right" v-if="item.balanceBefore!=null">
                      {{ get_currency(item.balanceBefore) }}</p>
                  </td>
                </template>
                <!--              <template #accBalance="{item}">-->
                <!--                <td :style="get_style(item)+'text-align:right'">-->
                <!--                  <p v-if="item.amount>item.amountNegetive" style="text-align:right">{{ get_currency(item.accBalance) }}</p>-->
                <!--                  <p v-else style="text-align:right">{{ get_currency(item.accBalanceNegetive) }}</p>-->
                <!--                </td>-->
                <!--              </template>-->


                <template #accBalance="{item}">
                  <td>
                    <p :style="'text-align:right; '+get_style_price(item,'accBalance')">{{
                        get_currency(item.accBalance)
                      }}</p>
                  </td>
                </template>


                <template #summary="{item}">
                  <td>
                    <p v-if="item.summary != 'null'">{{ item.summary }}</p>
                  </td>
                </template>
                <template #operation="{item}">
                  <td :class="get_style(item)">

                    <CButton
                        class="m-1"
                        color="primary"
                        square
                        size="sm"
                        :title="$t('payReceive')"
                        @click="goPayReceive(item)"
                    >
                      {{$t('payReceive')}}
                    </CButton>

                  </td>
                </template>
                <template #caption>
                  <tr class="total-table">

                    <td></td>
                    <td>{{ $t('totalCirculation') }}</td>
                    <td>{{ get_currency(calculate_items(items_filtered, 'amount')) }}</td>
                    <td>{{ get_currency(calculate_items(items_filtered, 'creditor')) }}</td>
                    <td>{{
                        get_currency(Math.abs(calculate_items(items_filtered, 'amount') +
                            calculate_items(items_filtered, 'creditor')))
                      }}
                    </td>
                    <td></td>
                  </tr>
                </template>
              </CDataTableFixed>

            </div>
          </CCardBody>
          <CCardFooter>

          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
    <CModal
            title="دریافت وجه"
            color="dark"
            size="lg"
            :show.sync="dialog_recept"
    >

      <ReceiveOperationModal
          :partyId="document_person_id"
          :partyName="document_person_name"
          :factorMasterId="doc_id"
          :docType.sync="docType"
          :show_doc_typ="true"
          :selectedMasterType="docType==3?80:163"
      />

      <template #footer>
        <CButton @click="dialog_recept = false" color="danger">{{ $t('buttons.cancel') }}</CButton>
      </template>
    </CModal>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../../main';
// import the styles
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import moment from 'moment-jalaali'
import ReceiveOperationModal from "../../receiveOperation/ReceiveOperationModal.vue";

var simulateAsync = null
const simulateAsyncOperation = fn => {
  if (simulateAsync != null) {
    clearTimeout(simulateAsync)
  }
  simulateAsync = setTimeout(fn, 1000)
}


export default {
  name: 'Login',
  components: {
    ReceiveOperationModal,
    Treeselect,
  },
  data() {
    return {
      dialog_recept:false,
      body_id:'tajmii_print_body',
      header_id:'tajmii_print_header',
      footer_id:'tajmii_print_footer',
      document_person_id:0,
      document_person_name:0,
      doc_id:0,
      docType:0,
      selected_type: 0,
      selected_person_type: 0,
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      selected_year: "2023",
      years_list: [],
      selected_tafsili_type: 2,
      table_clicks: 0,
      table_clicks_timer: null,
      validate_errors: [],
      selected_level: '',
      start_date: '',
      end_date: '',

      items: [],
      items_filtered: [],
      fields: [
        {key: 'row_id', label: this.$t('tables.row'), sorter: false, _style: 'width:3%'},
        // {key: 'docDate', label: this.$t('date'), _style: 'width:10%'},
        // {key: 'statusName', label: this.$t('documentType'), _style: 'width:15%'},
        // {key: 'masterId', label: this.$t('reference'), _style: 'width:7%'},
        // {key: 'payDocCode', label: this.$t('docNumber'), _style: 'width:7%'},
        {key: 'summary', label: this.$t('user'), _style: 'width:10%'},

        {key: 'amount', label: this.$t('tables.debtor'), _style: 'width:10%'},
        {key: 'creditor', label: this.$t('tables.creditor'), _style: 'width:10%'},
        {key: 'accBalance', label: this.$t('tables.balance'), _style: 'width:10%'},
        {key: 'operation', label: this.$t('tables.operation'), _style: 'width:10%'},
      ],

      status_form: 0,

      selected_person_name: '',
      selected_person: null,
      person_async_list: [],
      sync_person: true,
      person_name: '',
      accounting_list: [],
      moein_list: [],

      normalizer_persons(node) {
        return {
          id: node.userId,
          label: node.personCode + " " + node.userName + " " + node.surName,
        }
      },

    }
  },
  created() {
  },
  mounted() {

    this.$root.root_validate_errors = [];
    this.start_date = moment().locale('en').format("MM");
    this.end_date = this.get_today();
    // this.get_lists();
    this.get_lists();
  },
  watch: {
    'selected_type': function () {
      console.log("selected_type", this.selected_type)
      if (this.selected_type == 0) {
        this.items_filtered = this.items

      }
      if (this.selected_type == 1) {
        this.items_filtered = this.items.filter(x => x.accBalance < 0)

      }
      if (this.selected_type == 2) {
        this.items_filtered = this.items.filter(x => x.accBalance > 0)

      }
    }
  },
  methods: {
    goPayReceive(item){

      this.document_person_id = item.tafsiliId
      this.document_person_name = item.summary
      this.doc_id = 0
      this.docType = 3
      this.dialog_recept=true
    },
    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);


        bus.$emit('change_tajmi_all_to_one', {
          personId: item.tafsiliId,
          personCode: item.summary,
          personName: '',
        })
      }

    },
    get_style(item) {
      var color = '#56ff42';
      if (item.personAccountId == 0) {
        // return 'backgroundColor: \'#56ff42\'';
        return {
          backgroundColor: color
        }
      }
    },
    get_style_price(item, index) {
      var color = '#ff1403';
      // if(item.natureId==1){
      if (parseFloat(item[index]) < 0) {
        return 'color:#ff1403;'
      }
      // }
      // if(item.natureId==2){
      //   if (parseFloat(item[index]) > 0) {
      //     return 'color:#ff1403;'
      //   }
      // }

    },
    select_user(node, instance) {
      this.selected_person_name = node.fullName + " " + node.personCode;

    },
    get_lists() {
      var self = this;

      const formData = new FormData();


      // formData.append('PartyId', this.selected_person);
      // formData.append('ParentId', 10);
      formData.append('TypeId', this.selected_person_type);
      axios.post('GetAllPartyAccountsRpt', formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          self.items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
          self.items.forEach(function (val, index) {
            val.accBalance = val.amount + val.creditor

          })
          self.items = self.items.filter(x=>x.accBalance>1 || x.accBalance < -1)
          self.items_filtered = JSON.parse(JSON.stringify(self.items))
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_lists_groups() {

      var self = this;
      self.items_parent = [];
      self.data_with_children = []

      const formData = new FormData();
      var url = "Get_AllAccountingGroups";

      axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {

              self.accounting_list = response.data.data
              self.accounting_list.forEach((val) => {
                if (val.parentId == 0) {

                  self.get_childrens_one_sub(val.id, self.accounting_list).forEach((val2) => {

                    self.get_childrens_one_sub(val2.id, self.accounting_list).forEach((val3) => {

                      self.moein_list.push(val3)

                    });

                  });

                }

              });
            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

            }

          }
      )
          .catch(function (error) {
            console.log(error);
          });

    },
    get_childrens_one_sub(parent_id, list) {
      var array = [];
      var self = this;
      list.forEach((val2) => {

        if (parent_id == val2.parentId) {
          // var obj = {label: val2.accountCode + " " + val2.accountName, value: val2.id, code: val2.accountCode}
          array.push(val2);


        }
      });
      return array;
    },
    goToDocuments(item) {
      window.open('/dashboard/documents/show/' + item.masterId)
      // this.$router.push({path: '/dashboard/documents/show/' + item.masterId});

    },
    goToAccountingDoc(item) {
      window.open('/dashboard/accounting/show-accounting-doc/' + item.payDocId)
      // this.$router.push({path: '/dashboard/documents/show/' + item.masterId});

    },
  }
}

</script>
